module.exports = __webpack_public_path__ + "static/media/Profile.8aa944d4.jpg";